import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import { MbProductTabReference } from '../../../models'

export const MB_PRODUCT_TAB_REFERENCES_NORMALIZER = new InjectionToken<Converter<any, MbProductTabReference[]>>('MbProductTabReferencesListNormalizer')
